import Quote from '../../Quote/Quote';
import { colors } from '../../../ui-components';

class ContentTestimonials {
  constructor(contentfulNode) {
    this.title = contentfulNode?.title;
    this.sectionTitle = contentfulNode?.sectionTitle;
    this.subTitle = contentfulNode?.subtitle;
    this.linkUrl = contentfulNode?.linkURL;
    this.linkLabel = contentfulNode?.linkLabel;
    this.testimonials = contentfulNode?.testimonials.map(quote => new Quote(quote));
    this.type = 'CONTENT_TESTIMONIAL';
    this.defaultColor = colors.pureWhite;
  }
}

export { ContentTestimonials };
